import { supabase } from '../../shared/supabase/supabaseClient';
import {
  DEFAULT_BILLING_CATALOG,
  normalizePublicBillingCatalog,
  type PublicBillingCatalog,
} from '../../../../../shared/billing-catalog';

const BILLING_CATALOG_CACHE_MS = 60_000;
let billingCatalogInFlight: Promise<PublicBillingCatalog> | null = null;
let billingCatalogCache: { value: PublicBillingCatalog; fetchedAt: number } | null = null;

export function invalidatePublicBillingCatalogCache(): void {
  billingCatalogCache = null;
}

export async function fetchPublicBillingCatalog(): Promise<PublicBillingCatalog> {
  const now = Date.now();
  if (billingCatalogCache && now - billingCatalogCache.fetchedAt < BILLING_CATALOG_CACHE_MS) {
    return billingCatalogCache.value;
  }
  if (billingCatalogInFlight) {
    return billingCatalogInFlight;
  }

  billingCatalogInFlight = fetchPublicBillingCatalogRemote().finally(() => {
    billingCatalogInFlight = null;
  });
  return billingCatalogInFlight;
}

async function fetchPublicBillingCatalogRemote(): Promise<PublicBillingCatalog> {
  const { data, error } = await supabase.rpc('get_public_billing_catalog');
  if (error) {
    console.warn('[billingCatalog]', error.message);
    billingCatalogCache = { value: DEFAULT_BILLING_CATALOG, fetchedAt: Date.now() };
    return DEFAULT_BILLING_CATALOG;
  }
  const catalog = normalizePublicBillingCatalog(data);
  billingCatalogCache = { value: catalog, fetchedAt: Date.now() };
  return catalog;
}

export function getPublicBillingCatalogCache(): PublicBillingCatalog | null {
  return billingCatalogCache?.value ?? null;
}
